var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{class:_vm.classProps,attrs:{"elevation":"2","loading":_vm.loading,"dark":_vm.dark,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }